import axios, { AxiosInstance } from "axios";
import { logAcessoBaseURL, logAcessoNomeSolucao } from "../../variables";
import { buildLogAcessoApi } from "./LogAcessoApi";

export type RegisterPageAccessInput = {
  pagina: string;
  token: string;
  baseURL?: string;
  nomeSolucao?: string;
};

function trimApiBaseUrl(url: string): string {
  return url.replace(/\/$/, "");
}

function normalizeBearerToken(token: string): string {
  const trimmed = token.trim();
  if (!trimmed) return "";
  return trimmed.toLowerCase().startsWith("bearer ") ? trimmed : `Bearer ${trimmed}`;
}

function createLogAcessoApi(token: string, baseURL: string): AxiosInstance {
  const api = axios.create({
    baseURL: trimApiBaseUrl(baseURL),
    headers: { "Content-Type": "application/json" },
  });

  api.interceptors.request.use((config) => {
    config.headers = config.headers ?? {};
    if (token) {
      config.headers.Authorization = normalizeBearerToken(token);
    }
    return config;
  });

  return api;
}

export async function registerPageAccess(input: RegisterPageAccessInput): Promise<void> {
  const baseURL = input.baseURL ?? logAcessoBaseURL;
  if (!baseURL || !input.token) return;

  const client = buildLogAcessoApi(createLogAcessoApi(input.token, baseURL));
  await client.registrarAcesso({
    nomeSolucao: input.nomeSolucao ?? logAcessoNomeSolucao,
    pagina: input.pagina,
  });
}

export { buildLogAcessoApi };
export type { LogAcessoApi, LogAcessoRequest, LogAcessoResponse } from "./LogAcessoApi";
